import * as _ from 'underscore'

import { Toast } from 'mint-ui'
import axios from 'axios'
import router from './router'

export function addAdditionalAttrs(array, attrs, key) {
  let map = _.indexBy(attrs, key)
  return array.map(e => ({ ...e, ...map[e[key]] }))
}

export function goGame(url, from, courseId) {
  let host = window.location.host
  let redirect = `http://${host}/steps/${courseId}?from=${from}`
  window.location.href = `${url}?redirect=${encodeURIComponent(redirect)}`
}

export async function toItem(options: any) {
  let { data, type, index, from, albumId, tag_id, memId, share_username, bigAlbumId } = options
  switch (options.type) {
    case 'album':
      return router.push(`/albumInfo/${data.id}`)
      break
    case 'audio':
      let { listen, has_access, access_type } = data // listen是否可以试听 1可以  0不可以, has_access权限 1有权限听  0没有权限听
      if (has_access === 0 && listen === 0 && from !== 'qr') {
        return Toast(`${['sale_vip', 'vip'].includes(access_type) ? '当前为会员专属音频' : '当前为付费音频'}`, 'top')
      }
      let query = { audioId: data.id, index, from, memId, share_username }
      Object.assign(query, { albumId: bigAlbumId ? undefined : albumId || data.original_album_id, bigAlbumId })
      router.push({ path: `/play`, query })
      break
    default:
      return Toast(`不知道的类型${type}`, 'top')
      break
  }
}

export function pxToVW(num) {
  return `${100 * num / 750}vw`
}
export const countOccurences = (arr, value) => arr.reduce((a, v) => v === value ? a + 1 : a + 0, 0)
